__turbopack_context__.v({
  "app_light_theme": "Tip-module-scss-module__BPXquG__app_light_theme",
  "tooltip": "Tip-module-scss-module__BPXquG__tooltip",
  "tooltipContainer": "Tip-module-scss-module__BPXquG__tooltipContainer",
  "tooltip_bottom": "Tip-module-scss-module__BPXquG__tooltip_bottom",
  "tooltip_bottomLeft": "Tip-module-scss-module__BPXquG__tooltip_bottomLeft",
  "tooltip_bottomRight": "Tip-module-scss-module__BPXquG__tooltip_bottomRight",
  "tooltip_show": "Tip-module-scss-module__BPXquG__tooltip_show",
  "tooltip_top": "Tip-module-scss-module__BPXquG__tooltip_top",
  "tooltip_topLeft": "Tip-module-scss-module__BPXquG__tooltip_topLeft",
  "tooltip_topRight": "Tip-module-scss-module__BPXquG__tooltip_topRight",
});
